'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { fadeInUp, viewportOnce } from '@/lib/animations';

export default function SecurityBanner() {
    const t = useTranslations('Banner');

    const securityPoints = [
        {
            title: 'reason_1',
            description: 'reason_1_desc',
        },
        {
            title: 'reason_2',
            description: 'reason_2_desc',
        },
        {
            title: 'reason_3',
            description: 'reason_3_desc',
        },
    ];

    return (
        <motion.section
            className="w-full bg-white py-8 pb-12 px-6 sm:px-10 lg:px-16"
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            variants={fadeInUp}
        >
            <div className="max-w-8xl py-0 mx-auto relative rounded-3xl overflow-hidden shadow-2xl bg-[#01147D] bg-gradient-to-b from-[#001D9C] to-[#01147D] flex items-center">
                <Image
                    src="/images/homepage/security_banner.webp"
                    alt="Security background"
                    fill
                    priority
                    sizes="(max-width: 1280px) 100vw, 1280px"
                    className="hidden md:block object-contain object-right pointer-events-none select-none"
                />

                <div className="relative z-10 w-full p-8 sm:p-12 lg:p-16 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-center">
                    <div className="lg:col-span-4 space-y-2 max-w-lg">
                        <span className="text-xs sm:text-sm tracking-widest text-white uppercase">
                            {t('subtitle')}
                        </span>
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight leading-tight">
                            {t.rich('title', {
                                br: () => <br />,
                            })}
                        </h2>
                        <p className="text-sm sm:text-base text-blue-100 font-normal leading-relaxed opacity-90">
                            {t('description')}
                        </p>
                    </div>

                    <div className="lg:col-span-4 flex flex-col justify-center space-y-6 lg:pl-6">
                        {securityPoints.map((point, index) => (
                            <div key={index} className="flex items-start gap-4 group">
                                <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center shrink-0 mt-0.5 shadow-sm transition-transform duration-300 group-hover:scale-110">
                                    <svg className="w-4 h-4 color-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                <div className="space-y-0.5">
                                    <h3 className="text-base sm:text-lg font-bold text-white leading-snug">
                                        {t(point.title)}
                                    </h3>
                                    <p className="text-xs sm:text-sm text-blue-100/80 font-normal">
                                        {t(point.description)}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </motion.section>
    );
}
